// @flow
import { connect } from 'react-redux';
import UsageFrame from './UsageFrame';
import { canChangePlanOrOptionsOfCurrentSubscriptionSelector } from '../../../modules/Dashboard';
import { usagesSelector } from '../../../modules/Usage/selectors';
import { redirectAfterUsageFrameOnTitlePress } from '../../../actions/usage';
import { selectUsage } from '../../../modules/Usage/actions';

const mapStateToProps = state => ({
  isFetching: state.usage.summarizedUsages.fetching,
  usages: usagesSelector(state),
  canBoostPlan: canChangePlanOrOptionsOfCurrentSubscriptionSelector(state),
});

const mapDispatchToProps = {
  onUsagePress: selectUsage,
  onTitlePress: redirectAfterUsageFrameOnTitlePress,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsageFrame);
